<template>
  <div
    class="fixed bottom-0 left-1/2 transform -translate-x-1/2 w-full max-w-md bg-white border-t border-gray-200 py-2 flex justify-around z-50 rounded-xl mb-4"
  >
    <div class="home_container font-medium">
      <img class="mx-auto" src="/images/home_icon.svg" alt="" />
      <p>Home</p>
    </div>
    <div class="compass_container font-medium text-gray-400">
      <img class="mx-auto" src="/images/compass_icon.svg" alt="" />
      <p>Compass</p>
    </div>
    <div class="saved_container font-medium text-gray-400">
      <img class="mx-auto" src="/images/saved_icon.svg" alt="" />
      <p>Saved</p>
    </div>
    <div class="message_container font-medium text-gray-400">
      <img class="mx-auto" src="/images/message_icon.svg" alt="" />
      <p>Chat</p>
    </div>
  </div>
</template>

<script setup></script>
